import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const AdminPartsRequests = lazy(() => import("@/pages/admin/AdminPartsRequests"));

function AdminPartsRequestsRoute() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-background" />}>
      <AdminPartsRequests />
    </Suspense>
  );
}

export const Route = createFileRoute("/_adminLayout/admin/parts/requests")({
  component: AdminPartsRequestsRoute,
});
